import MainTestScenario from './MainTestScenario';
import { constants, Globals } from '../../../../misc/helpers';
import { ScenarioEndType } from '../../../../misc/BleedingControlScenario';

export default class MainTestScenarioSteps5And6 {
	constructor(private mainScenario: MainTestScenario, private onDone: (aarReady5: boolean) => void, public showFailedAar: () => void) {

		
	}

	start() {
		this.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedoutTimer, {
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			onTimeRanOut: () => {
				this.showFailedAar();
			},
			isActive: true
		});

		this.step1ApplyPressure();
	}

	private step1ApplyPressure() {
		var context = this;
		Globals.stopTimer = false;
		context.mainScenario.playSound('Step-3', '1', () => {
			this.mainScenario.playSound('Step-4', '1', () => {
				context.mainScenario.playSequence('VictimPlayLips');

				this.mainScenario.playSound('Step-4', '2', () => {
					context.mainScenario.playSequence('VictimStopLips');

				});
			});
		});
		this.mainScenario.playSequence('ApplyPressureSetup', null, ()=> {
			var isPlaying = false;

			//data start
			var setData = {
				disabled: false,
				dispatch: context.mainScenario.gameManager.customData.dispatch,
				onTapAndHold: () => {
						context.mainScenario.playSequence('SetBloodParticlePercentage', {
							zeroPercent: true,
							twentyFivePercent: false,
							fiftyPercent: false,
							seventyFivePercent: false,
							oneHundredPercent: true
						});
					if(!isPlaying) {
						setTimeout(() => {
							context.mainScenario.playSequence('VictimPlayLips');
							this.mainScenario.playSound('Step-5', '1', () => {
								this.mainScenario.playSound('Step-5', '2', () => {
									context.mainScenario.playSequence('VictimStopLips');
									this.mainScenario.playSound('Step-5', '3', () => {
										this.mainScenario.playSound('Step-6', '1', () => {
											context.mainScenario.playSequence('VictimPlayLips');
											this.mainScenario.playSound('Step-6', '2', () => {
												context.mainScenario.playSequence('VictimStopLips');
											});
										});
									});
								});
							});
						}, 2000);
			
					}

					isPlaying = true;
				},
				onReleased: () => {
					setData.disabled = true;
				context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.ApplyPressure, setData);
				setTimeout(() => {
					setTimeout(() => {
						setData.disabled = false;
						context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.ApplyPressure, setData);
					}, 2000)
					context.mainScenario.playSequence('SetBloodParticlePercentage', {
						zeroPercent: false,
						twentyFivePercent: false,
						fiftyPercent: false,
						seventyFivePercent: false,
						oneHundredPercent: true
					});
				}, 3000)
			},
				onDone: () => {
					setData.disabled = true;
					context.step2HasBleedingStoppedAudio()
					context.mainScenario.playSequence('SetBloodParticlePercentage', {
						zeroPercent: true,
						twentyFivePercent: false,
						fiftyPercent: false,
						seventyFivePercent: false,
						oneHundredPercent: false
					});
				}
			};
			//data end

			context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.ApplyPressure, setData);

		});
		this.mainScenario.playSequence('DisableBystander');
	}

	private step2HasBleedingStoppedAudio() {
		var context = this;
			this.mainScenario.aarApplyPressureDressing = true;
			this.mainScenario.aarApplyPressureWithPD = true;

		if((this.mainScenario.endAt === ScenarioEndType.pressureDressing) && (context.mainScenario.incorrectPathChosen === false)) {
			this.mainScenario.stopBleeding();
		}
		context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.ApplyPressure);

			if(this.mainScenario.endAt === ScenarioEndType.pressureDressing) {
				Globals.stopTimer = true;
				context.step2HasBleedingStoppedScenarioA();
			}
			else context.step2HasBleedingStopped();

	}

	private step2HasBleedingStopped() {
		var context = this;
	//	this.mainScenario.playSound('Step-6', '1', () => {
	//		this.mainScenario.playSound('Step-6', '2', () => {
	//		});
	//	});
				context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
					title: 'Has the bleeding stopped?',
					correctButton: {
						title: 'Yes',
						onClick: () => context.step2HasBleedingStoppedYes()
					},
					incorrectButton: {
						title: 'No',
						onClick: () => context.mainScenario.onAnsweredCorrectly('MainTestScenarioSteps5And6.step2HasBleedingStopped', () => {
							context.step2HasBleedingStoppedNo();
						})
					}
				});
				context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.LookAtObject, {
					dispatch: context.mainScenario.gameManager.customData.dispatch
		});
	}

	private step2HasBleedingStoppedScenarioA() {
		var context = this;

				context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
					title: 'Has the bleeding stopped?',
					correctButton: {
						title: 'Yes',
						onClick: () => context.mainScenario.onAnsweredCorrectly('MainTestScenarioSteps5And6.step2HasBleedingStopped', () => {
							context.step2HasBleedingStoppedYes();
						})
					},
					incorrectButton: {
						title: 'No',
						onClick: () => context.step2HasBleedingStoppedNo()
					}
				});
				context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.LookAtObject, {
					dispatch: context.mainScenario.gameManager.customData.dispatch
		});
	}

	private step2HasBleedingStoppedYes() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		if(this.mainScenario.endAt === ScenarioEndType.pressureDressing) {
			this.mainScenario.aarReassessAfterPD = true
		}
		else {
			this.mainScenario.aarReassessAfterPD = false;
		}
		this.mainScenario.playSound('Step-7', '1', () => {
			this.mainScenario.playSound('Step-7', '2', () => {
			context.step3RemovePressureDressing();
		});
	});
	}

	private step2HasBleedingStoppedNo() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		if(this.mainScenario.endAt === ScenarioEndType.pressureDressing) {
			this.mainScenario.aarReassessAfterPD = false
		}
		else {
			this.mainScenario.aarReassessAfterPD = true;
		}
		this.mainScenario.playSound('Step-7', '1', () => {
			this.mainScenario.playSound('Step-7', '2', () => {
			context.step3RemovePressureDressing();
		});
	});
	}

	private step3RemovePressureDressing() {
		var context = this;
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Do you want to remove the pressure dressing?',
			correctButton: {
				title: 'Yes',
				onClick: () => context.step3RemovePressureDressingYes()
			},
			incorrectButton: {
				title: 'No',
				onClick: () => context.mainScenario.onAnsweredCorrectly('MainTestScenarioSteps5And6.step3RemovePressureDressing', () => {
					context.step3RemovePressureDressingNo();
			})
			}
		});
	}

	private step3RemovePressureDressingYes() {
		this.mainScenario.aarPressureDressingNotRemoved = false;
		this.mainScenario.gameManager.UiManager.hideaAllUis();
		this.mainScenario.playSequence('SetBloodParticlePercentage', {
			zeroPercent: false,
			twentyFivePercent: false,
			fiftyPercent: true,
			seventyFivePercent: false,
			oneHundredPercent: false
		});
		this.onDone(true);
	}

	private step3RemovePressureDressingNo() {
		this.mainScenario.aarPressureDressingNotRemoved = true;
		this.mainScenario.playSequence('EnablePressureInVictim');
		this.mainScenario.gameManager.UiManager.hideaAllUis();
		this.mainScenario.playSequence('SetBloodParticlePercentage', {
			zeroPercent: true,
			twentyFivePercent: false,
			fiftyPercent: false,
			seventyFivePercent: false,
			oneHundredPercent: false
		});
		this.onDone(true);
	}
}